import {createStore} from "vuex";
import AuthStore from "@/js/Store/auth.store.js";
import AddressStore from "@/js/Store/address.store.js";
import CameraMediaStore from "@/js/Store/camera-media.store.js";
import CameraMediaObjectStore from "@/js/Store/camera-media-object.store.js";
import ChatStore from "@/js/Store/chat.store.js";
import ChatMessageStore from "@/js/Store/chat-message.store.js";
import ChatParticipantStore from "@/js/Store/chat-participant.store.js";
import ChatRoomStore from "@/js/Store/chat-room.store.js";
import EventStore from "@/js/Store/event.store.js";
import FloatingPanelStore from "@/js/Store/floating-panel.store.js";
import GeofenceStore from "@/js/Store/geofence.store.js";
import GeofenceGroupStore from "@/js/Store/geofence-group.store.js";
import HistoryStore from "@/js/Store/history.store.js";
import HistoryArrowStore from "@/js/Store/history-arrow.store.js";
import HistoryDashboardStore from "@/js/Store/history-dashboard.store.js";
import HistoryEventStore from "@/js/Store/history-event.store.js";
import HistoryPlayerStore from "@/js/Store/history-player.store.js";
import HistoryPositionStore from "@/js/Store/history-position.store.js";
import HistoryRouteStore from "@/js/Store/history-route.store.js";
import HistoryStopStore from "@/js/Store/history-stop.store.js";
import MapStore from "@/js/Store/map.store.js";
import ObjectStore from "@/js/Store/object.store.js";
import ObjectGroupStore from "@/js/Store/object-group.store.js";
import ObjectTailStore from "@/js/Store/object-tail.store.js";
import ObjectWidgetStore from "@/js/Store/object-widget.store.js";
import OverviewStore from "@/js/Store/overview.store.js";
import PayloadStore from "@/js/Store/payload.store.js";
import PaymentStore from "@/js/Store/payment.store.js";
import PermissionStore from "@/js/Store/permission.store.js";
import PoiStore from "@/js/Store/poi.store.js";
import PoiGroupStore from "@/js/Store/poi-group.store.js";
import RecentEventStore from "@/js/Store/recent-event.store.js";
import RouteStore from "@/js/Store/route.store.js";
import RouteGroupStore from "@/js/Store/route-group.store.js";
import ServerStore from "@/js/Store/server.store.js";
import SidebarStore from "@/js/Store/sidebar.store.js";
import TaskStore from "@/js/Store/task.store.js";
import SettableListStore from "@/js/Store/settable-list.store.js";
import AppStore from '@/js/Store/app.js';
import RegisterStore from "@/js/Store/register.store.js";
import QuickMenuStore from "@/js/Store/quick-menu.store.js";
import {applyToStore} from "@/js/helpers.js";
import FallowStore from "@/js/Store/fallow.store.js";
import BuilderStore from "@/js/Store/builder.store.js";

const modules = {
    'app': AppStore,
    'address': AddressStore,
    'auth': AuthStore,
    'camera-media': CameraMediaStore,
    'camera-media-object': CameraMediaObjectStore,
    'chat': ChatStore,
    'chat-message': ChatMessageStore,
    'chat-participant': ChatParticipantStore,
    'chat-room': ChatRoomStore,
    'event': EventStore,
    'floating-panel': FloatingPanelStore,
    'geofence': GeofenceStore,
    'geofence-group': GeofenceGroupStore,
    'history': HistoryStore,
    'history-arrow': HistoryArrowStore,
    'history-dashboard': HistoryDashboardStore,
    'history-event': HistoryEventStore,
    'history-player': HistoryPlayerStore,
    'history-position': HistoryPositionStore,
    'history-route': HistoryRouteStore,
    'history-stop': HistoryStopStore,
    'map': MapStore,
    'object': ObjectStore,
    'object-group': ObjectGroupStore,
    'object-tail': ObjectTailStore,
    'object-widget': ObjectWidgetStore,
    'overview': OverviewStore,
    'payload': PayloadStore,
    'payment': PaymentStore,
    'permission': PermissionStore,
    'poi': PoiStore,
    'poi-group': PoiGroupStore,
    'recent-event': RecentEventStore,
    'route': RouteStore,
    'route-group': RouteGroupStore,
    'server': ServerStore,
    'sidebar': SidebarStore,
    'task': TaskStore,
    'settable-list': SettableListStore,
    'register': RegisterStore,
    'quick-menu': QuickMenuStore,
    'fallow': FallowStore,
    'builder': BuilderStore,
};

export default {
    install(app, data = {}) {
        const store = createStore({ modules });
        applyToStore(data, store);
        app.use(store);
    },
}